import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {
  _setCboName,
  _setOrganization,
  _setAcceptsCCCMS,
  _setCbpCode,
  _setFirstReferralContact,
  _setSecondReferralContact,
  _setLastVerWk,
  _setCup,
  _setModality,
  _setEnhancedServicesRate,
  _setSTOPBeds,
  _setVerificationContact,
  _setVerificationContact2,
  _setSlecupNALtrDate,
  _setCupMaxBeds,
  _setGender,
  _setGenderOldObject,
  _setGenderNewObject,
  _setBlanketPurchaseAgreementDedCapSap,
  _setMaxAdmits,
  _setWcVeificationContact1,
  _setWcVeificationContact2,
  _setADPEffDate,
  _setADPLicCert,
  _setAccepts290s,
  _setFoodProvided,
  _setCalOMSContact,
  _setWcCalOMSContacts1,
  _setWcCalOMSContact2,
  _setADPExpDate,
  _setADPMaxBeds,
  _setDataDepartmentComment,
  _setSap,
  _setBPADedCap,
  _setInactive,
  _setFlagged,
  _setVerLock,
  _setCupNA,
  _setCurrentFYRateSheetReceivedandVerified,
  _setOverorUnderDARSApprovedCountyRate,
  _setContractComplianceStatusNote,
  _setLowIntensity,
  _setMedIntensity,
  _setHighIntensity,
} from './cbpFormActions';
import initialState from './cbpFormInitialState';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getCbpForm = createAsyncThunk(
  'stop/getCbpForm',
  async (params) => {
    const { commonParams, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(commonParams, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const cbpFormSlice = createSlice({
  name: 'stop/cbpForm',
  initialState,
  reducers: {
    newCBPForm: (state, action) => action.payload,
    setCboName: _setCboName,
    setOrganization: _setOrganization,
    setAcceptsCCCMS: _setAcceptsCCCMS,
    setCbpCode: _setCbpCode,
    setFirstReferralContact: _setFirstReferralContact,
    setSecondReferralContact: _setSecondReferralContact,
    setLastVerWk: _setLastVerWk,
    setCup: _setCup,
    setModality: _setModality,
    setEnhancedServicesRate: _setEnhancedServicesRate,
    setSTOPBeds: _setSTOPBeds,
    setVerificationContact: _setVerificationContact,
    setVerificationContact2: _setVerificationContact2,
    setSlecupNALtrDate: _setSlecupNALtrDate,
    setCupMaxBeds: _setCupMaxBeds,
    setGender: _setGender,
    setGenderOldObject: _setGenderOldObject,
    setGenderNewObject: _setGenderNewObject,
    setBlanketPurchaseAgreementDedCapSap: _setBlanketPurchaseAgreementDedCapSap,
    setMaxAdmits: _setMaxAdmits,
    setWcVeificationContact1: _setWcVeificationContact1,
    setWcVeificationContact2: _setWcVeificationContact2,
    setADPEffDate: _setADPEffDate,
    setADPLicCert: _setADPLicCert,
    setAccepts290s: _setAccepts290s,
    setFoodProvided: _setFoodProvided,
    setCalOMSContact: _setCalOMSContact,
    setWcCalOMSContacts1: _setWcCalOMSContacts1,
    setWcCalOMSContact2: _setWcCalOMSContact2,
    setADPExpDate: _setADPExpDate,
    setADPMaxBeds: _setADPMaxBeds,
    setDataDepartmentComment: _setDataDepartmentComment,
    setSap: _setSap,
    setBPADedCap: _setBPADedCap,
    setInactive: _setInactive,
    setFlagged: _setFlagged,
    setVerLock: _setVerLock,
    setCupNA: _setCupNA,
    setCurrentFYRateSheetReceivedandVerified:
      _setCurrentFYRateSheetReceivedandVerified,
    setOverorUnderDARSApprovedCountyRate: _setOverorUnderDARSApprovedCountyRate,
    setContractComplianceStatusNote: _setContractComplianceStatusNote,
    setLowIntensity: _setLowIntensity,
    setMedIntensity: _setMedIntensity,
    setHighIntensity: _setHighIntensity,
  },
  extraReducers: {
    [getCbpForm.fulfilled]: (state, action) => action.payload,
  },
});

export const {
  newCBPForm,
  setCboName,
  setOrganization,
  setAcceptsCCCMS,
  setCbpCode,
  setFirstReferralContact,
  setSecondReferralContact,
  setLastVerWk,
  setCup,
  setModality,
  setEnhancedServicesRate,
  setSTOPBeds,
  setVerificationContact,
  setVerificationContact2,
  setSlecupNALtrDate,
  setCupMaxBeds,
  setGender,
  setGenderOldObject,
  setGenderNewObject,
  setBlanketPurchaseAgreementDedCapSap,
  setMaxAdmits,
  setWcVeificationContact1,
  setWcVeificationContact2,
  setADPEffDate,
  setADPLicCert,
  setAccepts290s,
  setFoodProvided,
  setCalOMSContact,
  setWcCalOMSContacts1,
  setWcCalOMSContact2,
  setADPExpDate,
  setADPMaxBeds,
  setDataDepartmentComment,
  setSap,
  setBPADedCap,
  setInactive,
  setFlagged,
  setVerLock,
  setCupNA,
  setCurrentFYRateSheetReceivedandVerified,
  setOverorUnderDARSApprovedCountyRate,
  setContractComplianceStatusNote,
  setLowIntensity,
  setMedIntensity,
  setHighIntensity,
} = cbpFormSlice.actions;

export default cbpFormSlice.reducer;
